(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gabriel-brand-film"] && !Shopify.designMode) return;
  try {
    function setupGabrielFilms(){document.querySelectorAll('[data-ga-film]:not([data-ready])').forEach(media=>{
 media.dataset.ready='true';const video=media.querySelector('video'),error=media.querySelector('[role="status"]');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'),connection=navigator.connection;let inView=false,userPaused=false,blocked=false,pending=false;
 const icons=()=>{video.setAttribute('aria-label',video.paused?video.dataset.play:video.dataset.pause)};
 const mayAuto=()=>!reduced.matches&&!connection?.saveData;
 function start(manual=false){if(pending||document.hidden||(!manual&&(!inView||userPaused||blocked||!mayAuto())))return;pending=true;if(!video.getAttribute('src'))video.src=video.dataset.src;video.muted=true;video.defaultMuted=true;error.hidden=true;video.play().then(()=>{blocked=false;if(!inView||document.hidden)video.pause()}).catch(()=>{blocked=true;icons()}).finally(()=>{pending=false})}
 function sync(){if(!inView||document.hidden)video.pause();else start()}
 const toggle=()=>{if(!video.paused){userPaused=true;video.pause()}else{userPaused=false;blocked=false;inView=true;start(true)}};video.addEventListener('click',toggle);video.addEventListener('keydown',event=>{if(event.key===' '||event.key==='Enter'){event.preventDefault();toggle()}});
 ['play','pause','ended'].forEach(event=>video.addEventListener(event,icons));
 video.addEventListener('error',()=>{blocked=true;error.hidden=false;icons()});
 if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.intersectionRatio>=.55)inView=true;else if(entry.intersectionRatio<.2)inView=false;sync()}},{threshold:[0,.2,.55,1]});observer.observe(video)}
 document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',()=>{if(!mayAuto())video.pause();else sync()});icons();
})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupGabrielFilms);else setupGabrielFilms();
document.addEventListener('shopify:section:load',setupGabrielFilms);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gabriel-hero-slideshow"] && !Shopify.designMode) return;
  try {
    (function(){
function start(){
document.querySelectorAll('[data-ga-hero-slideshow]').forEach(root=>{
if(root.dataset.ready)return;
root.dataset.ready='true';
const slides=Array.from(root.querySelectorAll('[data-ga-slide]')),dots=Array.from(root.querySelectorAll('[data-ga-dot]')),controls=root.querySelector('.ga-hero-slide-controls'),pause=root.querySelector('[data-ga-pause]'),status=root.querySelector('[data-ga-slide-status]'),reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
if(slides.length<2)return;
controls.hidden=false;
let active=0,timer=null,userPaused=false,hovered=false,focused=false,inView=true,touchX=null,touchY=null;
function stop(){clearTimeout(timer);timer=null}
function schedule(){stop();if(!userPaused&&!hovered&&!focused&&inView&&!document.hidden&&!reduced.matches)timer=setTimeout(()=>show(active+1,false),4500)}
function show(index,manual){
const next=(index+slides.length)%slides.length;
slides.forEach((slide,i)=>{const selected=i===next;slide.classList.toggle('is-active',selected);slide.setAttribute('aria-hidden',String(!selected));slide.inert=!selected;slide.tabIndex=selected?0:-1;dots[i].setAttribute('aria-current',String(selected))});
active=next;
const upcoming=slides[(active+1)%slides.length].querySelector('img');if(upcoming)upcoming.loading='eager';
if(manual)status.textContent=slides[active].getAttribute('aria-label');
schedule();
}
function updatePause(){pause.setAttribute('aria-pressed',String(userPaused));pause.setAttribute('aria-label',userPaused?pause.dataset.playLabel:pause.dataset.pauseLabel);schedule()}
root.querySelector('[data-ga-prev]').addEventListener('click',()=>show(active-1,true));
root.querySelector('[data-ga-next]').addEventListener('click',()=>show(active+1,true));
dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i,true)));
pause.addEventListener('click',()=>{userPaused=!userPaused;updatePause()});
root.addEventListener('mouseenter',()=>{hovered=true;stop()});
root.addEventListener('mouseleave',()=>{hovered=false;schedule()});
root.addEventListener('focusin',()=>{focused=true;stop()});
root.addEventListener('focusout',()=>{setTimeout(()=>{focused=root.contains(document.activeElement);schedule()},0)});
root.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();show(active+(event.key==='ArrowRight'?1:-1),true)}});
root.addEventListener('touchstart',event=>{touchX=event.changedTouches[0].clientX;touchY=event.changedTouches[0].clientY;stop()},{passive:true});
root.addEventListener('touchend',event=>{if(touchX===null)return;const x=event.changedTouches[0].clientX-touchX,y=event.changedTouches[0].clientY-touchY;if(Math.abs(x)>50&&Math.abs(x)>Math.abs(y)*1.4)show(active+(x<0?1:-1),true);else schedule();touchX=null},{passive:true});
document.addEventListener('visibilitychange',schedule);
reduced.addEventListener('change',schedule);
if('IntersectionObserver' in window)new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;schedule()},{threshold:.15}).observe(root);
show(0,false);
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

})();
